module.exports = __webpack_public_path__ + "img/C04TechBowman2_ua.384d4a34.webp";